import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IActionItemFlirPhotosSuccessPayload, IActionItemPhotosFailurePayload, IActionItemPhotosSuccessPayload, IActionRoomFlirPhotosSuccessPayload, IActionRoomPhotosFailurePayload, IActionRoomPhotosSuccessPayload, IBlobError, IBlobRequest, IBlobSuccess, IFlirPhotoRemove, IFlirPhotoRemoveFailure, IFlirPhotoSaveRequest, IFlirPhotoSaveSuccess, IFlirPhotosRequest, IItemFlirPhotoRemove, IItemFlirPhotoRemoveFailure, IItemFlirPhotoSave, IItemFlirPhotoSaveSuccess, IItemPhotoRemove, IItemPhotoRemoveFailure, IItemPhotoRequest, IItemPhotoSave, IItemPhotoSaveSuccess, IPhotoRemove, IPhotoRemoveFailure, IPhotoSaveRequest, IPhotoSaveSuccess, IPhotosRequest, IPhotosState, IShowPhotoViewer, IUploadComplete, IUploadError, IUploadPercentage, IUploadRequest, IUploadSave } from './types'


const initialState: IPhotosState = {
  itemFlirPhotos: {},
  itemPhotos: {},
  roomFlirPhotos: {},
  roomPhotos: {},
  uploads: [],
  blobs: {}
}

export const photosSlice = createSlice({
  name: 'photos',
  initialState,
  reducers: {
    //LIST PHOTOS
    roomPhotosRequest: (state, action: PayloadAction<IPhotosRequest>) => {
      state.roomPhotos[action.payload.roomId] = {
        isLoading: true,
        data: state.roomPhotos[action.payload.roomId]?.data || []
      }
    },

    roomPhotosSuccess: (state, action: PayloadAction<IActionRoomPhotosSuccessPayload>) => {
      state.roomPhotos[action.payload.roomId] = {
        isLoading: false,
        data: action.payload.data
      }
    },

    roomPhotosFailure: (state, action: PayloadAction<IActionRoomPhotosFailurePayload>) => {
      state.roomPhotos[action.payload.roomId] = {
        isLoading: false,
        data: state.roomPhotos[action.payload.roomId]?.data || [],
        error: action.payload.error
      }
    },
    //LIST PHOTOS FLIR
    roomPhotosFlirRequest: (state, action: PayloadAction<IFlirPhotosRequest>) => {
      state.roomFlirPhotos[action.payload.roomId] = {
        isLoading: true,
        data: state.roomFlirPhotos[action.payload.roomId]?.data || []
      }
    },

    roomPhotosFlirSuccess: (state, action: PayloadAction<IActionRoomFlirPhotosSuccessPayload>) => {
      state.roomFlirPhotos[action.payload.roomId] = {
        isLoading: false,
        data: action.payload.data
      }
    },

    roomPhotosFlirFailure: (state, action: PayloadAction<IActionRoomPhotosFailurePayload>) => {
      state.roomFlirPhotos[action.payload.roomId] = {
        isLoading: false,
        data: state.roomFlirPhotos[action.payload.roomId]?.data || [],
        error: action.payload.error
      }
    },
    // UPLOAD
    fileUpload: (state, action: PayloadAction<IUploadRequest>) => {
      const upload = action.payload
      state.uploads = [...state.uploads, {
        id: upload.id,
        entityId: upload.entityId,
        percentage: 0,
        file: upload.file
      }]
    },
    fileUploadSetPercentage(state, action: PayloadAction<IUploadPercentage>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.id) return upload;

        return {
          ...upload,
          percentage: action.payload.percentage
        }
      })
    },
    fileUploadError(state, action: PayloadAction<IUploadError>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.uploadId) return upload;

        return {
          ...upload,
          isSaving: false,
          error: action.payload.error
        }
      })
    },
    fileUploadSavingState(state, action: PayloadAction<IUploadSave>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.uploadId) return upload;

        return {
          ...upload,
          isSaving: action.payload.isSaving
        }
      })
    },
    fileUploadComplete(state, action: PayloadAction<IUploadComplete>) {
      state.uploads = state.uploads.filter(upload => upload.id !== action.payload.uploadId);
    },
    // ROOM PHOTOS *** SAVE ***
    roomPhotoSaveRequest(state, action: PayloadAction<IPhotoSaveRequest>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.uploadId) return upload;

        return {
          ...upload,
          isSaving: true
        }
      })
    },
    roomPhotoSaveSuccess(state, action: PayloadAction<IPhotoSaveSuccess>) {
      const { roomId, photo } = action.payload;

      if (!state.roomPhotos[roomId]) {
        state.roomPhotos = {
          ...state.roomPhotos,
          [roomId]: {
            data: [photo],
            isLoading: false,
            error: undefined
          }
        }
      }
      else state.roomPhotos[roomId].data = [...state.roomPhotos[roomId].data, photo];
    },
    // ROOM PHOTOS *** DELETE ***
    roomPhotoRemoveRequest(state, action: PayloadAction<IPhotoRemove>) {
      state.roomPhotos = {
        ...state.roomPhotos,
        [action.payload.roomId]: {
          data: state.roomPhotos[action.payload.roomId].data.map(photo => {
            if (photo.id !== action.payload.photoId) return photo;

            return {
              ...photo,
              isDeleting: true
            }
          }),
          isLoading: false,
          error: undefined
        }
      }
    },
    roomPhotoRemoveSuccess(state, action: PayloadAction<IPhotoRemove>) {
      state.roomPhotos = {
        ...state.roomPhotos,
        [action.payload.roomId]: {
          data: state.roomPhotos[action.payload.roomId].data.filter(photo => photo.id !== action.payload.photoId),
          isLoading: false,
          error: undefined
        }
      }
    },

    roomPhotoRemoveFailure: (state, action: PayloadAction<IPhotoRemoveFailure>) => {
      state.roomPhotos = {
        ...state.roomPhotos,
        [action.payload.roomId]: {
          data: state.roomPhotos[action.payload.roomId].data.map(photo => {
            if (photo.id !== action.payload.photoId) return photo;

            return {
              ...photo,
              isDeleting: false
            }
          }),
          isLoading: false,
          error: action.payload.error
        }
      }
    },
    // ROOM FLIR PHOTOS *** SAVE ***
    roomFlirPhotoSaveRequest(state, action: PayloadAction<IFlirPhotoSaveRequest>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.uploadNormalId && upload.id !== action.payload.uploadFlirId) return upload;
        return {
          ...upload,
          isSaving: true
        }
      })
    },
    roomFlirPhotoSaveSuccess(state, action: PayloadAction<IFlirPhotoSaveSuccess>) {
      const { roomId, flirPhoto } = action.payload;

      if (!state.roomFlirPhotos[roomId]) {
        state.roomFlirPhotos = {
          ...state.roomFlirPhotos,
          [roomId]: {
            data: [flirPhoto],
            isLoading: false,
            error: undefined
          }
        }
      }
      else state.roomFlirPhotos[roomId].data = [...state.roomFlirPhotos[roomId].data, flirPhoto];
    },
    // ROOM FLIR PHOTOS *** DELETE *** 
    roomFlirPhotoRemoveRequest(state, action: PayloadAction<IFlirPhotoRemove>) {
      state.roomFlirPhotos = {
        ...state.roomFlirPhotos,
        [action.payload.roomId]: {
          data: state.roomFlirPhotos[action.payload.roomId].data.map(photo => {
            if (photo.id !== action.payload.flirPhotoId) return photo;

            return {
              ...photo,
              isDeleting: true
            }
          }),
          isLoading: false,
          error: undefined
        }
      }
    },
    roomFlirPhotoRemoveSuccess(state, action: PayloadAction<IFlirPhotoRemove>) {
      state.roomFlirPhotos = {
        ...state.roomFlirPhotos,
        [action.payload.roomId]: {
          data: state.roomFlirPhotos[action.payload.roomId].data.filter(photo => photo.id !== action.payload.flirPhotoId),
          isLoading: false,
          error: undefined
        }
      }
    },

    roomFlirPhotoRemoveFailure: (state, action: PayloadAction<IFlirPhotoRemoveFailure>) => {
      state.roomFlirPhotos = {
        ...state.roomFlirPhotos,
        [action.payload.roomId]: {
          data: state.roomFlirPhotos[action.payload.roomId].data.map(photo => {
            if (photo.id !== action.payload.flirPhotoId) return photo;

            return {
              ...photo,
              isDeleting: false
            }
          }),
          isLoading: false,
          error: action.payload.error
        }
      }
    },
    // ITEM PHOTOS
    itemPhotosRequest: (state, action: PayloadAction<IItemPhotoRequest>) => {
      state.itemPhotos[action.payload.itemId] = {
        isLoading: true,
        data: state.itemPhotos[action.payload.itemId]?.data || []
      }
    },

    itemPhotosSuccess: (state, action: PayloadAction<IActionItemPhotosSuccessPayload>) => {
      state.itemPhotos[action.payload.itemId] = {
        isLoading: false,
        data: action.payload.data
      }
    },

    itemPhotosFailure: (state, action: PayloadAction<IActionItemPhotosFailurePayload>) => {
      state.itemPhotos[action.payload.itemId] = {
        isLoading: false,
        data: state.itemPhotos[action.payload.itemId]?.data || [],
        error: action.payload.error
      }
    },
    // ITEM PHOTO *** SAVE ***
    itemPhotoSaveRequest(state, action: PayloadAction<IItemPhotoSave>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.uploadId) return upload;

        return {
          ...upload,
          isSaving: true
        }
      })
    },
    itemPhotoSaveSuccess(state, action: PayloadAction<IItemPhotoSaveSuccess>) {
      const { itemId, photo } = action.payload;

      if (!state.itemPhotos[itemId]) {
        state.itemPhotos = {
          ...state.itemPhotos,
          [itemId]: {
            data: [photo],
            isLoading: false,
            error: undefined
          }
        }
      }
      else state.itemPhotos[itemId].data = [...state.itemPhotos[itemId].data, photo];
    },
    // ITEM PHOTOS *** DELETE ***
    itemPhotoRemoveRequest(state, action: PayloadAction<IItemPhotoRemove>) {

      state.itemPhotos = {
        ...state.itemPhotos,
        [action.payload.itemId]: {
          data: state.itemPhotos[action.payload.itemId].data.map(photo => {
            if (photo.id !== action.payload.photoId) return photo;

            return {
              ...photo,
              isDeleting: true
            }
          }),
          isLoading: false,
          error: undefined
        }
      }
    },
    itemPhotoRemoveSuccess(state, action: PayloadAction<IItemPhotoRemove>) {
      state.itemPhotos = {
        ...state.itemPhotos,
        [action.payload.itemId]: {
          data: state.itemPhotos[action.payload.itemId].data.filter(photo => photo.id !== action.payload.photoId),
          isLoading: false,
          error: undefined
        }
      }
    },

    itemPhotosRemoveFailure: (state, action: PayloadAction<IItemPhotoRemoveFailure>) => {
      state.itemPhotos = {
        ...state.itemPhotos,
        [action.payload.itemId]: {
          data: state.itemPhotos[action.payload.itemId].data.map(photo => {
            if (photo.id !== action.payload.photoId) return photo;

            return {
              ...photo,
              isDeleting: false
            }
          }),
          isLoading: false,
          error: action.payload.error
        }
      }
    },
    // ITEM FLIR PHOTOS 
    itemPhotosFlirRequest: (state, action: PayloadAction<IItemPhotoRequest>) => {
      state.itemFlirPhotos[action.payload.itemId] = {
        isLoading: true,
        data: state.itemFlirPhotos[action.payload.itemId]?.data || []
      }
    },

    itemPhotosFlirSuccess: (state, action: PayloadAction<IActionItemFlirPhotosSuccessPayload>) => {
      state.itemFlirPhotos[action.payload.itemId] = {
        isLoading: false,
        data: action.payload.data
      }
    },

    itemPhotosFlirFailure: (state, action: PayloadAction<IActionItemPhotosFailurePayload>) => {
      state.itemFlirPhotos[action.payload.itemId] = {
        isLoading: false,
        data: state.itemFlirPhotos[action.payload.itemId]?.data || [],
        error: action.payload.error
      }
    },
    //ITEM FLIR PHOTOS *** SAVE ***
    itemFlirPhotoSaveRequest(state, action: PayloadAction<IItemFlirPhotoSave>) {
      state.uploads = state.uploads.map(upload => {
        if (upload.id !== action.payload.uploadNormalId && upload.id !== action.payload.uploadFlirId) return upload;

        return {
          ...upload,
          isSaving: true
        }
      })
    },
    itemFlirPhotoSaveSuccess(state, action: PayloadAction<IItemFlirPhotoSaveSuccess>) {
      const { itemId, flirPhoto } = action.payload;

      if (!state.itemFlirPhotos[itemId]) {
        state.itemFlirPhotos = {
          ...state.itemFlirPhotos,
          [itemId]: {
            data: [flirPhoto],
            isLoading: false,
            error: undefined
          }
        }
      }
      else state.itemFlirPhotos[itemId].data = [...state.itemFlirPhotos[itemId].data, flirPhoto];
    },
    //ITEM FLIR PHOTOS *** DELETE *** 
    itemFlirPhotoRemoveRequest(state, action: PayloadAction<IItemFlirPhotoRemove>) {

      state.itemFlirPhotos = {
        ...state.itemFlirPhotos,
        [action.payload.itemId]: {
          data: state.itemFlirPhotos[action.payload.itemId].data.map(flirPhoto => {
            if (flirPhoto.id !== action.payload.flirPhotoId) return flirPhoto;

            return {
              ...flirPhoto,
              isDeleting: true
            }
          }),
          isLoading: false,
          error: undefined
        }
      }
    },
    itemFlirPhotoRemoveSuccess(state, action: PayloadAction<IItemFlirPhotoRemove>) {
      state.itemFlirPhotos = {
        ...state.itemFlirPhotos,
        [action.payload.itemId]: {
          data: state.itemFlirPhotos[action.payload.itemId].data.filter(flirPhoto => flirPhoto.id !== action.payload.flirPhotoId),
          isLoading: false,
          error: undefined
        }
      }
    },

    itemFlirPhotosRemoveFailure: (state, action: PayloadAction<IItemFlirPhotoRemoveFailure>) => {
      state.itemFlirPhotos = {
        ...state.itemFlirPhotos,
        [action.payload.itemId]: {
          data: state.itemFlirPhotos[action.payload.itemId].data.map(flirPhoto => {
            if (flirPhoto.id !== action.payload.flirPhotoId) return flirPhoto;

            return {
              ...flirPhoto,
              isDeleting: false
            }
          }),
          isLoading: false,
          error: action.payload.error
        }
      }
    },
    // BLOBS
    blobRequest(state, action: PayloadAction<IBlobRequest>) {
      state.blobs = {
        ...state.blobs,
        [action.payload.link]: {
          isLoading: true
        }
      }
    },
    blobSuccess(state, action: PayloadAction<IBlobSuccess>) {
      state.blobs = {
        ...state.blobs,
        [action.payload.link]: {
          isLoading: false,
          blob: action.payload.blob
        }
      }
    },
    blobFailure(state, action: PayloadAction<IBlobError>) {
      state.blobs = {
        ...state.blobs,
        [action.payload.link]: {
          isLoading: false,
          error: action.payload.error
        }
      }
    },

    //SHOW PHOTOS
    showPhotoViewer(state, action: PayloadAction<IShowPhotoViewer>) {
      state.photoViewer = action.payload
    },
    stopShowPhotoViewer(state) {
      state.photoViewer = undefined
    },
    //SHOW PHOTO FLIR
    showPhotoFlirViewer(state, action: PayloadAction<IShowPhotoViewer>) {
      state.photoViewer = action.payload
    },
    stopShowPhotoFlirViewer(state) {
      state.photoViewer = undefined
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  roomPhotosRequest,
  roomPhotosSuccess,
  roomPhotosFailure,
  roomPhotosFlirRequest,
  roomPhotosFlirSuccess,
  roomPhotosFlirFailure,
  fileUpload,
  fileUploadSetPercentage,
  fileUploadError,
  fileUploadSavingState,
  fileUploadComplete,
  roomPhotoSaveRequest,
  roomPhotoSaveSuccess,
  roomPhotoRemoveRequest,
  roomPhotoRemoveSuccess,
  roomPhotoRemoveFailure,
  roomFlirPhotoSaveRequest,
  roomFlirPhotoSaveSuccess,
  roomFlirPhotoRemoveRequest,
  roomFlirPhotoRemoveSuccess,
  roomFlirPhotoRemoveFailure,
  itemPhotosRequest,
  itemPhotosSuccess,
  itemPhotosFailure,
  itemPhotosFlirRequest,
  itemPhotosFlirSuccess,
  itemPhotosFlirFailure,
  itemPhotoSaveRequest,
  itemPhotoSaveSuccess,
  itemPhotoRemoveRequest,
  itemPhotoRemoveSuccess,
  itemPhotosRemoveFailure,
  itemFlirPhotoSaveRequest,
  itemFlirPhotoSaveSuccess,
  itemFlirPhotoRemoveRequest,
  itemFlirPhotoRemoveSuccess,
  itemFlirPhotosRemoveFailure,
  blobRequest,
  blobSuccess,
  blobFailure,
  showPhotoViewer,
  stopShowPhotoViewer,
  showPhotoFlirViewer,
  stopShowPhotoFlirViewer,
} = photosSlice.actions

export default photosSlice.reducer